getThumbnailsCompressNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/CompressedFileSeqOptional"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: getThumbnailsCompressNode
    tags:
      - Thumbnail
    summary: 複数ファイルのサムネイル画像の取得
    description: |
      ### 複数のファイルのサムネイル画像を取得します。
      
      `node`は情報取得対象ファイルが存在するフォルダの識別コードです。
      
      レスポンスで取得したダウンロードURLにアクセスすることで、ZIP形式で圧縮された複数のサムネイル画像をダウンロードできます。
      
      複数のファイルのfile_seqを半角のカンマ（,）で区切り、パラメータに指定してダウンロードすることもできます。
      
      リクエスト時、以下にあてはまると、エラーが発生します。
      
      - ファイルの総数が2000個を超過した場合
      
      - ダウンロードの権限がない場合

    security:
      - AccessToken: [ ]

    responses:
      "200":
        description: ファイル情報取得成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/CompressedLinkInfo"
      "default":
        description: ファイル情報取得失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FileOrDirectoryNotExists"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionThumbnail"
              Exceeding Allowable Number:
                $ref: "../openapi/response.error.yaml#/ExceedingAllowableNumber"